import React from 'react';
import { DollarSign } from 'lucide-react';
import AdminCRUD from '../../components/admin/AdminCRUD';

const STATUS = { successful:'bg-emerald-100 text-emerald-700', failed:'bg-red-100 text-red-700', pending:'bg-amber-100 text-amber-700' };
const Badge = ({ v, map, fallback='bg-gray-100 text-gray-600' }) => (
  <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold capitalize ${map[v] || fallback}`}>{v}</span>
);

export default function AdminDonations() {
  return (
    <AdminCRUD
      endpoint="donations"
      title="Donations"
      icon={DollarSign}
      columns={[
        { key:'donorName', label:'Donor', render:(v,item) => (
          <div>
            <div className="font-semibold text-gray-900">{item.isAnonymous ? 'Anonymous' : (v || '—')}</div>
            <div className="text-xs text-gray-400">{item.email}</div>
          </div>
        )},
        { key:'amount', label:'Amount', render: v => <span className="font-bold text-royal-800">₦{v?.toLocaleString()}</span> },
        { key:'program', label:'Program', render: v => v || '—' },
        { key:'status', label:'Status', render: v => <Badge v={v} map={STATUS} /> },
        { key:'paymentMethod', label:'Method', render: v => <span className="text-xs text-gray-500 capitalize">{v?.replace('_',' ')}</span> },
        { key:'createdAt', label:'Date', render: v => <span className="text-xs text-gray-400">{new Date(v).toLocaleDateString('en-NG')}</span> },
      ]}
      defaultForm={{ donorName:'', email:'', amount:'', currency:'NGN', program:'General Fund', status:'pending', paymentMethod:'paystack', isAnonymous:false }}
      formFields={[
        { key:'donorName', label:'Donor Name', required:true },
        { key:'email', label:'Email', type:'email', required:true },
        { key:'amount', label:'Amount (₦)', type:'number', required:true },
        { key:'program', label:'Program' },
        { key:'paymentMethod', label:'Payment Method', type:'select', options:['paystack','bank_transfer','other'] },
        { key:'status', label:'Status', type:'select', options:['pending','successful','failed'] },
        { key:'transactionRef', label:'Transaction Reference' },
        { key:'message', label:'Message', type:'textarea', fullWidth:true },
        { key:'isAnonymous', label:'Anonymous Donation', type:'checkbox', checkLabel:'Donor is anonymous', fullWidth:true },
      ]}
    />
  );
}
